(function () {
  function initSlider(section) {
    var slider = section.querySelector('[data-et-bundle-reviews-slider]');

    if (!slider || slider.dataset.initialized === 'true' || typeof Swiper === 'undefined') {
      return;
    }

    if (!slider.querySelector('.swiper-slide')) {
      slider.hidden = true;
      return;
    }

    slider.dataset.initialized = 'true';

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      pagination: {
        el: slider.querySelector('.et-bundle-reviews__pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3
      },
      scrollbar: {
        el: slider.querySelector('.et-bundle-reviews__scrollbar'),
        draggable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }

  function initSection(section) {
    if (!section.classList.contains('et-bundle-reviews')) {
      return;
    }

    initSlider(section);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    window.addEventListener('load', callback, { once: true });
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-reviews').forEach(initSection);
  }

  function boot() {
    whenSwiperReady(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      initSection(event.target);
    });
  });
})();
